import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const carkeyPresentService = {
    getAllcarkeyPresents,
    getcarkeyPresent,
    updatecarkeyPresent,
    createcarkeyPresent,
    updatecarkeyPresentStatus
};

const MODULE = {
    PRESENT: 'car-key-presents',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllcarkeyPresents(filter) {
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        is_locked: filter.isLocked,
        is_active: filter.isActive, 
      }
    }
    
    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
  
    return apiHelper(API_URL).get(`/${MODULE.PRESENT}`, requestOptions)
  }

  export function getcarkeyPresent(id) {   
    return apiHelper(API_URL).get(`/${MODULE.PRESENT}/${id}`)
  }

  export function updatecarkeyPresent(data) {
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).put(`/${MODULE.PRESENT}/${data.id}`, requestOptions)
  }

  export function createcarkeyPresent(data) {
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).post(`/${MODULE.PRESENT}`, requestOptions)
  }

  export function updatecarkeyPresentStatus(data) {
    const requestOptions = {
      is_active: data.isActive
    }
    
    return apiHelper(API_URL).patch(`/${MODULE.PRESENT}/${data.id}`, requestOptions)
    
  }